import type { FaireProductEntity } from "../../entity_types/product";

export const p_pcqzyns48c: FaireProductEntity = {
  token: "p_pcqzyns48c",
  type: "product",
  name: "HALTER NECK STRIPED TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/0b17031a63cd7881c6b5638062ace1dac4e06f8967c324768ba8b3d09f1212f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a70cf652de54e56a950377193c92a3ee7d010cde17a93f573208fe5b78cd010.jpeg",
    "https://cdn.faire.com/fastly/1cca57ce7475cbf6fdd164d04ef8562d1607c10e19adde79bce1691cab78d357.jpeg",
    "https://cdn.faire.com/fastly/be4dcd6a8813ec6ed1f0c148c010efc21ce2e2f545639301eeb16834f7ab1112.jpeg",
    "https://cdn.faire.com/fastly/7bef6c76b93931ae6958d43f4a5358a18c90a957b7cffe8b1f5aeb02df9f140e.jpeg",
    "https://cdn.faire.com/fastly/efcc2894c85dc6bcb7f1c149878d0979b8e2de1b742437bd51e4cd1ec2cb9198.jpeg",
  ],
  priceDollars: 120,
  description:
    '**TOP ONLY**\n\n(MATCHING SET WITH: PS7527)\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 240,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:08.617Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
